'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    ExterneOrganisationResource = _require2.ExterneOrganisationResource;

module.exports.ExterneOrganisation = function (_BaseEntity) {
  _inherits(ExterneOrganisation, _BaseEntity);

  _createClass(ExterneOrganisation, null, [{
    key: '__name__',
    value: function __name__() {
      return 'externeorganisation';
    }
  }]);

  function ExterneOrganisation(data) {
    _classCallCheck(this, ExterneOrganisation);

    var _this = _possibleConstructorReturn(this, (ExterneOrganisation.__proto__ || Object.getPrototypeOf(ExterneOrganisation)).call(this));

    _this._entityName = 'de.ul.fob.domain.ExterneOrganisation';
    _this.beschreibung = null;
    _this.hsNr = null;
    _this.idHs = null;
    _this.kurzname = null;
    _this.name = null;
    _this.stadt = null;

    _this.land = null;
    _get(ExterneOrganisation.prototype.__proto__ || Object.getPrototypeOf(ExterneOrganisation.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(ExterneOrganisation, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'beschreibung', 'hsNr', 'idHs', 'kurzname', 'name', 'stadt'],
        links: ['land']
      });
    }
  }, {
    key: 'fetchLand',
    value: function fetchLand() {
      return _get(ExterneOrganisation.prototype.__proto__ || Object.getPrototypeOf(ExterneOrganisation.prototype), 'genericResolve', this).call(this, 'land');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(ExterneOrganisation.prototype.__proto__ || Object.getPrototypeOf(ExterneOrganisation.prototype), 'genericResolve', this).call(this, 'land')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof ExterneOrganisationResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(ExterneOrganisation.prototype.__proto__ || Object.getPrototypeOf(ExterneOrganisation.prototype), 'fetchQuery', this).call(this, ExterneOrganisationResource);
      }
    }
  }]);

  return ExterneOrganisation;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/externeOrganisation.js
// module id = FM51
// module chunks = 0